import { ColumnFilterItem } from 'antd/lib/table/interface';

import { Listing, StaticContentItem } from 'shared/interfaces';
import { store } from 'store';
import { ListingStatusId } from 'utils/const';

/**
 * Get listing status id from a listing.
 *
 * @param value Listing info.
 * @return Returns listing status id.
 */
const getListingStatusId = (listing: Listing): number =>
  listing?.listingStatusReason?.listingStatus?.id;

/**
 * Checks if listing status is live.
 *
 * @param value Listing info.
 * @return Returns true if is live, else false.
 */
export const isListingStatusLive = (listing: Listing): boolean =>
  getListingStatusId(listing) === ListingStatusId.Live;

/**
 * Checks if listing status is removed.
 *
 * @param value Listing info.
 * @return Returns true if is removed, else false.
 */
export const isListingStatusRemoved = (listing: Listing): boolean =>
  getListingStatusId(listing) === ListingStatusId.Removed;

/**
 * Checks if listing status is hidden.
 *
 * @param value Listing info.
 * @return Returns true if is hidden, else false.
 */
export const isListingStatusHidden = (listing: Listing): boolean =>
  getListingStatusId(listing) === ListingStatusId.Hidden;

/**
 * Checks if listing status is created.
 *
 * @param value Listing info.
 * @return Returns true if is created, else false.
 */
export const isListingStatusCreated = (listing: Listing): boolean =>
  getListingStatusId(listing) === ListingStatusId.Created;

/**
 * Checks if listing status is sold.
 *
 * @param value Listing info.
 * @return Returns true if is sold, else false.
 */
export const isListingStatusSold = (listing: Listing): boolean =>
  getListingStatusId(listing) === ListingStatusId.Sold;

/**
 * Checks if listing status id is hidden.
 *
 * @param value Listing status id.
 * @return Returns true if is hidden, else false.
 */
export const isListingStatusIdHidden = (listingStatusId: number): boolean => {
  return listingStatusId === ListingStatusId.Hidden;
};

/**
 * Build key value objet from static content listing Statuses.
 *
 * @return Returns listing status as [{value, text}].
 */
export const getListingStatusFilters = (): ColumnFilterItem[] => {
  const listingStatuses = store.getState().staticContent?.data?.listingStatuses;

  return listingStatuses?.map((status: StaticContentItem) => {
    return { value: status.id, text: status.name };
  });
};
